import externals from "utils/externals";
import { getItemAnon } from "utils/localstorage";
const envVars = {}

/**
 * Set environment-specific variables.
 * You can add more env-specific assignments here as needed.
 */
switch (process.env.REACT_APP_ENDPOINTS) {
    case 'dev':
        envVars.orgId = "ab1b998a-2b40-4d4b-9d03-c4d3f6532243";
        envVars.orgId2 = "a1e43837-fc1b-483a-b0b8-52d24f374cd4";
        break;
    case 'staging':
        envVars.orgId = "e429d12d-8f60-4cc4-ac3b-bce2ecf3e376";
        envVars.orgId2 = "b476dfc7-ff16-42c3-a7d7-5db27a422544";
        break;
    case 'preprod':
    case 'prod':
    default:
        envVars.orgId = "ab1b998a-2b40-4d4b-9d03-c4d3f6532243";
        envVars.orgId2 = "a1e43837-fc1b-483a-b0b8-52d24f374cd4";
        break;
}

envVars.orgId = getItemAnon({ itemKey: 'vtOrgId' }) || envVars.orgId;
envVars.legacyId = getItemAnon({ itemKey: 'vtLegacyId' }) || envVars.orgId;

export default {
    "version": "1.0",
    "authBackend": "https://" + process.env.REACT_APP_AUTH0_DOMAIN,
    "orgs": [
        {
            "id": envVars.orgId,
            "isSystem": "false",
            "legacyId": envVars.legacyId,
            "links": [],
            "name": "Simulated-Organization-1",
            "ownerOrganizationId": envVars.orgId,
            "resourceClass": "hierarchy",
            "resourceType": "organization"
        },
        {
            "id": envVars.orgId2,
            "isSystem": "false",
            "legacyId": envVars.legacyId,
            "links": [],
            "name": "Simulated-Organization-2",
            "ownerOrganizationId": envVars.orgId2,
            "resourceClass": "hierarchy",
            "resourceType": "organization"
        }
    ],
    "partnerOrgs": [
        {
            "id": "a1e43837-fc1b-483a-b0b8-52d24f374c22",
            "isSystem": "false",
            "legacyId": "a1e43837-fc1b-483a-b0b8-52d24f374c22",
            "links": [],
            "name": "Simulated partner",
            "ownerOrganizationId": "a1e43837-fc1b-483a-b0b8-52d24f374c22",
            "resourceClass": "hierarchy",
            "resourceType": "organization"
        }
    ],
    "resources": [
        {
            "id": "77eaad5a-45a4-4d6a-8d4e-3023330ddc72",
            "isSystem": "false",
            "legacyId": "workspaceiGqJMyk0",
            "name": "Simulated-Project-1",
            "ownerOrganizationId": envVars.orgId,
            "parentId": envVars.orgId,
            "resourceClass": "hierarchy",
            "resourceType": "project"
        }
    ],
    "agents": [
        {
            "agentId": "Di0pAOtIRGGOz6qwRpkbVnsyTQMwHLDhclients",
            "name": "Simulated-AWS-US-West-Agent"
        },
        {
            "agentId": "G7tXqu7aTWm4vsVRl3uw3Qxtck9buOJwclients",
            "name": "Simulated-AWS-US-East-Agent"
        },
        {
            "agentId": "098oZv6XSgWBhH03ckdfBOOdnmGFSJrRclients",
            "name": "Simulated-GCP-Agent"
        },
        {
            "agentId": "0aag4uYQQxS7PTfZJCQyD3xrReVWVobkclients",
            "name": "Simulated-AZURE-Agent"
        }
    ],
    "users": [
        {
            "aadId": "ed00c2dd-25d7-42b3-a897-6877aa1e6ad8",
            "auth0Id": "auth0|61b87ee74574f5006c5eb558",
            "id": "aa4e7588-bf09-4dcf-9d73-57ddae01a958",
            "name": "John Doe",
            "email": "john.doe@netapp.com",
            "legacyId": "user-WmqHKGuj"
        }
    ],
    ...externals
}
